import 'owl.carousel';

export class EventsBanner{
    public static init(){

        var numberOfSlides = 4;
        if(window.innerWidth < 510){
            numberOfSlides = 1;
        }
         else if(window.innerWidth < 950){
             numberOfSlides = 2;
        }

        const slider = $('.owl-carousel');

        slider.on('initialized.owl.carousel', function () {

            slider.find('.owl-item').attr('aria-selected','false');
            slider.find('.owl-item').attr('aria-hidden','true');
            slider.find('.owl-item').find('a').attr('tabindex','-1');
            slider.find('.owl-item.active').attr('aria-selected','true');
            slider.find('.owl-item.active').attr('aria-hidden','false');
            slider.find('.owl-item.active').find('a').attr('tabindex','0');

            // apply meta info to next and previous buttons and make them focusable
            slider.find('.owl-prev').attr('role','button').attr('title','Previous');
            slider.find('.owl-next').attr('role','button').attr('title','Next');
            $('.owl-prev, .owl-next').attr('tabindex','0');
        });

        slider.on('changed.owl.carousel', function() {
            slider.find('.owl-item').attr('aria-selected','false');
            slider.find('.owl-item').attr('aria-hidden','true');
            slider.find('.owl-item').find('a').attr('tabindex','-1');
            slider.find('.owl-item.active').attr('aria-selected','true');
            slider.find('.owl-item.active').attr('aria-hidden','false');
            slider.find('.owl-item.active').find('a').attr('tabindex','0');
        });

        slider.owlCarousel({
            nav: true,
            items: numberOfSlides,
            autoHeight: true,
            pagination: false,
            addClassActive: true
        });
    }
}
